import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { ProgressBar } from "primereact/progressbar";
import { FlexColumn, TextWrapper } from "../../../constants/common/StyledGlobalConstants";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";

const { TABLET } = DEVICE_BREAKPOINTS;

// Progress configuration constants
const PROGRESS_CONFIG = {
  TOTAL_SECONDS: 15,
  MAX_PROGRESS_PERCENT: 98,
  FALLBACK_PROGRESS_PERCENT: 99,
  UPDATE_INTERVAL_MS: 1000,
};

function FetchSlotsProgress() {
  const [value, setValue] = useState(0);
  const interval = useRef(null);
  const progressRef = useRef(null);

  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const isMobile = windowSize.width < TABLET;

  useEffect(() => {
    // Initialize seconds counter
    let seconds = 0;
    // Start interval to update progress every second
    interval.current = setInterval(() => {
      seconds += 1; // Increment seconds
      // Calculate percent based on elapsed seconds (out of total seconds)
      const percent = Math.round((seconds * 100) / PROGRESS_CONFIG.TOTAL_SECONDS);
      // If percent exceeds max threshold, cap at fallback percentage and stop interval
      if (percent > PROGRESS_CONFIG.MAX_PROGRESS_PERCENT) {
        clearInterval(interval.current);
        setValue(PROGRESS_CONFIG.FALLBACK_PROGRESS_PERCENT);
      } else {
        // Otherwise, update progress value
        setValue(percent);
      }
    }, PROGRESS_CONFIG.UPDATE_INTERVAL_MS);

    // Scroll progress message into view
    progressRef?.current?.scrollIntoView({
      behavior: "smooth",
    });

    // Cleanup interval on unmount
    return () => clearInterval(interval.current);
  }, []);

  return (
    <FlexColumn alignItems="center" alignContent="center" marginTop="2.5rem">
      <TextWrapper fontWeight="700" fontSize="1.5rem" lineHeight="2rem" fontFamily="neue-haas-grotesk-display">
        {Math.floor(value)}%
      </TextWrapper>
      <TextWrapper fontWeight="400" fontSize="0.875rem" marginTop="0.5rem !important" ref={progressRef}>
        Loading available appointments
      </TextWrapper>
      <ProgressBar
        value={Math.floor(value)}
        showValue={false}
        color="#008331"
        style={{
          width: isMobile ? "100%" : "17rem",
          height: "0.5rem",
          borderRadius: "0rem",
          marginTop: "0.5rem",
          marginBottom: "1rem",
        }}
      ></ProgressBar>
    </FlexColumn>
  );
}

export default FetchSlotsProgress;
